/** Horizontally scrollable table wrapper (.table-wrap). */
export default function TableWrap({ children, ...rest }) {
  return <div className="table-wrap" {...rest}>{children}</div>;
}
